import { createContext, useContext } from 'react';

import { AccordionContextValue, AccordionItemContextValue } from './types';

export const AccordionContext = createContext<AccordionContextValue | null>(null);
AccordionContext.displayName = 'AccordionContext';

export const AccordionItemContext = createContext<AccordionItemContextValue | null>(null);
AccordionItemContext.displayName = 'AccordionItemContext';

export const useAccordionContext = (): AccordionContextValue => {
    const context = useContext(AccordionContext);

    if (!context) {
        throw new Error('Accordion compound components must be used within Accordion');
    }

    return context;
};

export const useAccordionItemContext = (): AccordionItemContextValue => {
    const context = useContext(AccordionItemContext);

    if (!context) {
        throw new Error('Accordion.Button and Accordion.Panel must be used within Accordion.Item');
    }

    return context;
};
